/**
 * This is a server model and should only be used on the server boundary, not
 * in the client code. See `MarketplaceState` in
 * `@yoop/consumer-app/transaction/model`.
 */
export enum ServerMarketplaceState {
  CANCELLED = 'CANCELLED',
  PAUSED = 'PAUSED',
  WINNERS_SELECTED = 'WINNERS_SELECTED',
  ALLOCATE_READY = 'ALLOCATE_READY',
}

/**
 * This is a server model and should only be used on the server boundary, not
 * in the client code. See `MarketplaceType` in
 * `@yoop/consumer-app/transaction/model`.
 */
export enum ServerMarketplaceType {
  DRAW = 'DRAW',
  AUCTION = 'AUCTION',
  PURCHASE = 'PURCHASE',
  SECONDARY_EXCHANGE = 'SECONDARY_EXCHANGE',
  PROMOTER = 'PROMOTER',
  CLIENT_GUEST = 'CLIENT_GUEST',
}
